import { useFeatureFlag } from './useFeatureFlag';
import { useUniqueIdForThisMount } from './useUniqueIdForThisMount';
import { useWidgetTabIdForUserViewKey } from 'src/lib/featureFlags/flags/useWidgetTabIdForUserViewKey';

export function useWidgetTableUserViewKey(tabId: string): string {
    const uniqueId = useUniqueIdForThisMount();
    const useTabId = useFeatureFlag(useWidgetTabIdForUserViewKey);

    return useTabId ? tabId : uniqueId;
}
